import Store from '../../src/redux';
import { sendRequest, sendRequestV2, sendRequestV5, sendRequestV4, sendRequestV7, sendRequestV1Post, sendRequestV8, sendRequestTarde } from './baseRequest';

const getHeaders = () => {
  const user = Store?.getState()?.user;
  return {
    'X-FNOTRADER-SECRET': user?.loginSecret,
    'X-FNOTRADER-USERID': user?.userID,
  };
};

export const getFutureTicks = () => {
  return sendRequest('get', 'get_future_ticks', {}, getHeaders());
};
export const getAllFutureTicksData = () => {
  return sendRequest('get', 'get_all_future_ticks', {}, getHeaders());
};
export const getPreMarketTicksReq = () => {
  return sendRequest('get', 'get_pre_market_ticks', {}, getHeaders());
};

export const getAllFutureTicksDataWithTime = (time) => {
  return sendRequest(
    'get',
    `get_all_future_ticks?time=${time}`,
    {},
    getHeaders()
  );
};

export const getFutureInstruments = () => {
  return sendRequest('get', 'get_future_instruments', {}, getHeaders());
};

export const getFutureAllInstruments = () => {
  return sendRequest('get', 'get_all_future_instruments', {}, getHeaders());
};
export const getPreMarketInstrumentsReq = () => {
  return sendRequest('get', 'get_pre_market_instruments', {}, getHeaders());
};

export const getOptionChainInstrumentsNames = () => {
  return sendRequest('get', 'search', {}, getHeaders());
};

export const getOptionChainExpiries = (instrument) => {
  return sendRequest(
    'get',
    `get_option_expiry?name=${encodeURIComponent(instrument)}`,
    {},
    getHeaders()
  );
};

export const getSpotToken = (instrument, exchange) => {
  return sendRequest(
    'get',
    `instruments?name=${encodeURIComponent(instrument)}&exchange=${exchange}`,
    {},
    getHeaders()
  );
};

export const getSpotTokenPrice = (token) => {
  return sendRequest('get', `ticks?tokens=${token}`, {}, getHeaders());
};

export const getOptionChainInstruments = (instrument, expiry) => {
  return sendRequest(
    'get',
    `get_option_chain_instruments?name=${encodeURIComponent(
      instrument
    )}&expiry=${expiry}`,
    {},
    getHeaders()
  );
};

export const getTick = (ticks) => {
  return sendRequest('get', `ticks?tokens=${ticks}`, {}, getHeaders());
};

export const getChartData = (symbol, to, from, seletedInterval) => {
  return sendRequestV7(
    'get',
    `pattern?tokens=${symbol}&type=${seletedInterval}&to=${to}T15:30&from=${from}T09:00`,
    {},
    getHeaders()
  );
};

export const getStrategyData = (type, to, from, symbol) => {
  return sendRequestV1Post(
    "post",
    `strategy-new?type=${type}&to=${to}&from=${from}`,
    symbol,
    getHeaders()
  );
};

export const getChartDataOptionOI = (symbol, to, from, seletedInterval) => {
  return sendRequestV7(
    'get',
    `pattern?tokens=${symbol}&type=${seletedInterval}&to=${to}&from=${from}`,
    {},
    getHeaders()
  );
};

//  Custom Option
export const getCustomOption = (
  symbol,
  to,
  from,
  seletedInterval,
  selectExpiry,
  slectedStrikes
) => {
  return sendRequest(
    'get',
    `get_aggregated_oi?token=${symbol}&type=${seletedInterval}&from=${from}&to=${to}&expiry=${selectExpiry}&strike=${slectedStrikes}`,
    // `get_aggregated_oi?token=256265&type=5m&from=2024-04-08T09%3A15&to=2024-04-08T15%3A30&expiry=2024-04-10&strike=10`,
    {},
    getHeaders()
  );
};

export const getHolidaysByExchange = (exgs) => {
  return sendRequest(
    'get',
    `get_exchange_holidays?exchange=${exgs}`,
    {},
    getHeaders()
  );
};

export const getsearchAPIRequest = (params, filter) => {
  return sendRequestV5(
    'get',
    `search?query=${encodeURIComponent(params)}&filter=${filter}`,
    {},
    getHeaders()
  );
};

export const getStockSectorAPIRequest = () => {
  return sendRequest('get', `get_index_sector`, {}, getHeaders());
};

export const getIndexAtmInstrumentsRequest = () => {
  return sendRequest('get', `get_index_atm_instruments`, {}, getHeaders());
};

export const getCashMarketRequest = (to, from) => {
  return sendRequest(
    'get',
    `get_cash_market?to=${to}&from=${from}`,
    {},
    getHeaders()
  );
};

export const getIndexStatsRequest = (to, from) => {
  return sendRequest(
    'get',
    `get_index_stats?to=${to}&from=${from}`,
    {},
    getHeaders()
  );
};

export const getFnoOIRequest = (to, from) => {
  return sendRequest(
    'get',
    `get_fno_oi?to=${to}&from=${from}`,
    {},
    getHeaders()
  );
};

export const getSpotCumulativeRequest = (filter, type, date) => {
  return sendRequest(
    'get',
    `get_spot_cumulative?filter=${filter}&type=${type}&to=${date}T15:30&from=${date}T09:15`,
    {},
    getHeaders()
  );
};

export const getSpotCumulativeRequestWithTime = (filter, type, to, from) => {
  return sendRequest(
    'get',
    `get_spot_cumulative?filter=${filter}&type=${type}&to=${to}&from=${from}`,
    {},
    getHeaders()
  );
};

export const getOptionInstrumentByStrikeRequest = (
  name,
  type,
  expiry,
  strike
) => {
  return sendRequest(
    'get',
    `option_instrument?name=${name}&type=${type}&expiry=${expiry}&strike=${strike}`,
    {},
    getHeaders()
  );
};

export const getFutureEodRequest = (symbol, to, from, type) => {
  return sendRequest(
    'get',
    `get_fao_eod?from=${from}&type=${type}&to=${to}&tokens=${symbol}`,
    {},
    getHeaders()
  );
};

export const getFutureCashEodRequest = (symbol, to, from, type) => {
  return sendRequest(
    'get',
    `get_cash_market_eod?from=${from}&type=${type}&to=${to}&tokens=${symbol}`,
    {},
    getHeaders()
  );
};

export const getEodRequest = (symbol, to, from, type) => {
  return sendRequest(
    'get',
    `get_eod?from=${from}&type=${type}&to=${to}&tokens=${symbol}`,
    {},
    getHeaders()
  );
};

export const getRawTicksRequest = (symbol, to, from) => {
  return sendRequest(
    'get',
    `raw_ticks?from=${from}&to=${to}&token=${symbol}`,
    {},
    getHeaders()
  );
};

export const getEodv4Request = (symbol, to, from, type) => {
  return sendRequestV4(
    'get',
    `get_eod?from=${from}&type=${type}&to=${to}&tokens=${symbol}`,
    {},
    getHeaders()
  );
};

export const getFuturesEodAnalysisData = (param) => {
 
  return sendRequestV4(
    'get',
    `rollover?${param}`,
    {},
    getHeaders()
  );
};

export const getGexExpiryRequest = (symbol, expiry, from, to) => {
  return sendRequestV2(
    'get',
    `get_gex_expiry?instrument=${symbol}&expiry=${expiry}&from=${from}&to=${to}`,
    {},
    getHeaders()
  );
};

export const getGexforStrikeRequest = (symbol, expiry, from, to, strike) => {
  return sendRequestV2(
    'get',
    `get_gex_for_strike?instrument=${symbol}&expiry=${expiry}&from=${from}&to=${to}&strike=${strike}`,
    {},
    getHeaders()
  );
};

export const getGexforExpiryStrikeWiseRequest = (symbol, expiry) => {
  return sendRequestV2(
    'get',
    `get_gex_for_expiry_strike_wise?instrument=${symbol}&expiry=${expiry}`,
    {},
    getHeaders()
  );
};

export const getSeasonalityRequest = (token) => {
  return sendRequestV2(
    'get',
    `seasonality?token=${token}`,
    {},
    getHeaders()
  );
};

export const getReferralEarnings = () => {
  return sendRequestTarde(
    'get',
    `referral-earnings`,
    {},
    getHeaders()
  );
};